import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AnimatedLoading } from './styles';
export function Loading({ color, size, 'data-testid': dataTestId }) {
    return (_jsxs(AnimatedLoading, { "data-testid": dataTestId || 'loading-icon', className: "loading-icon", size: size, color: color, children: [_jsx("div", { className: "loading-fragment" }), _jsx("div", { className: "loading-fragment" }), _jsx("div", { className: "loading-fragment" }), _jsx("div", { className: "loading-fragment" })] }));
}
//# sourceMappingURL=index.js.map